import { useParams } from 'react-router-dom'

import RejectLeave from 'modules/timeoff/components/RejectLeave'

import { useOnClose } from './useOnClose'

const RejectLeavePage = () => {
  const { leave_id: leaveId, id } = useParams()
  const onClose = useOnClose(id)

  if (leaveId === undefined) {
    return null
  }

  return <RejectLeave leaveId={+leaveId} onClose={onClose} />
}

export default RejectLeavePage
